import React, { forwardRef } from 'react';
import { Box, FormControl, FormHelperText, InputLabel } from '@mui/material';
import { CustomTextInput } from '../TextInput/TextInput';
import { alpha } from '@mui/material/styles';
import { Autocomplete } from '@mui/material';

interface IProps {
  label: string | null;
  type?: string;
  error?: boolean;
  helperText?: string | null;
  defaultValue?: string;
  multiple?: boolean;
  /* eslint-disable-next-line */
  value: any;
  selectOptions: { value: string; label: string }[];
  disabled?: boolean;
}

const AutocompleteSelectInput = forwardRef(
  (
    {
      label = null,
      type = 'text',
      error,
      helperText,
      selectOptions = [],
      defaultValue = '',
      multiple,
      value,
      disabled,
      ...other
    }: IProps,
    ref
  ) => {
    return (
      <Box sx={{ width: '100%', margin: '12px 0' }}>
        {label && (
          <InputLabel
            // id="demo-customized-select-label1"
            shrink
            //htmlFor="demo-customized-select1"
            sx={{
              color: error ? '#F9473C' : '#5E6366',
              pl: 1,
              '&.Mui-focused': {
                color: error ? '#F9473C' : '#5E6366 !important',
              },
            }}
          >
            {label}
          </InputLabel>
        )}
        <FormControl variant="standard" fullWidth error={error}>
          <Autocomplete
            isOptionEqualToValue={(option, value) => {
              if (value === '') return true;
              return option.value === value.value;
            }}
            ref={ref}
            id="demo-customized-select1"
            //renderInput={(params) => <TextField {...params} />}
            renderInput={(params) => (
              <div ref={params.InputProps.ref}>
                <CustomTextInput type="text" {...params} />
              </div>
            )}
            defaultValue={defaultValue}
            sx={[
              helperText
                ? {
                    boxShadow: (theme) =>
                      `${alpha(theme.palette.error.main, 0.5)} 0 0 0 0.2rem`,
                    borderColor: (theme) => theme.palette.error.main,
                    borderRadius: '8px',
                  }
                : {},
            ]}
            value={value || null}
            options={selectOptions}
            disabled={disabled}
            {...other}
          />
          {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      </Box>
    );
  }
);

export default AutocompleteSelectInput;
